const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttackgraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: "attackGraphSVG",
    title: "attackgraph",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1280,663.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-973.0129737295306,-303.3611079958978)scale(0.8304700240908941)",
    style: {
      font: "8px sans-serif"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M0,0C150,0 150,-316.875 300,-316.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M0,0C175,0 175,-226.875 350,-226.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M0,0C175,0 175,316.875 350,316.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,961.875C1575,961.875 1575,931.875 1750,931.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,961.875C1575,961.875 1575,961.875 1750,961.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,961.875C1575,961.875 1575,991.875 1750,991.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,901.875C1925,901.875 1925,841.875 2100,841.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,901.875C1925,901.875 1925,871.875 2100,871.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,901.875C1925,901.875 1925,901.875 2100,901.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,901.875C1925,901.875 1925,931.875 2100,931.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,901.875C1925,901.875 1925,961.875 2100,961.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,886.875C1575,886.875 1575,871.875 1750,871.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,886.875C1575,886.875 1575,901.875 1750,901.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,924.375C1225,924.375 1225,886.875 1400,886.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,924.375C1225,924.375 1225,961.875 1400,961.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,811.875C1575,811.875 1575,781.875 1750,781.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,811.875C1575,811.875 1575,811.875 1750,811.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,811.875C1575,811.875 1575,841.875 1750,841.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,691.875C1575,691.875 1575,631.875 1750,631.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,691.875C1575,691.875 1575,661.875 1750,661.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,691.875C1575,691.875 1575,691.875 1750,691.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,691.875C1575,691.875 1575,721.875 1750,721.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,691.875C1575,691.875 1575,751.875 1750,751.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,736.875C1225,736.875 1225,661.875 1400,661.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,736.875C1225,736.875 1225,691.875 1400,691.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,736.875C1225,736.875 1225,751.875 1400,751.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,736.875C1225,736.875 1225,811.875 1400,811.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,586.875C1225,586.875 1225,541.875 1400,541.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,586.875C1225,586.875 1225,571.875 1400,571.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,586.875C1225,586.875 1225,601.875 1400,601.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,586.875C1225,586.875 1225,631.875 1400,631.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,740.625C875,740.625 875,556.875 1050,556.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,740.625C875,740.625 875,586.875 1050,586.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,740.625C875,740.625 875,661.875 1050,661.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,740.625C875,740.625 875,736.875 1050,736.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,740.625C875,740.625 875,924.375 1050,924.375",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,511.875C1575,511.875 1575,481.875 1750,481.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,511.875C1575,511.875 1575,511.875 1750,511.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,511.875C1575,511.875 1575,541.875 1750,541.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,451.875C1925,451.875 1925,391.875 2100,391.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,451.875C1925,451.875 1925,421.875 2100,421.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,451.875C1925,451.875 1925,451.875 2100,451.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,451.875C1925,451.875 1925,481.875 2100,481.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,451.875C1925,451.875 1925,511.875 2100,511.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,436.875C1575,436.875 1575,421.875 1750,421.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,436.875C1575,436.875 1575,451.875 1750,451.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,474.375C1225,474.375 1225,436.875 1400,436.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,474.375C1225,474.375 1225,511.875 1400,511.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,361.875C1575,361.875 1575,331.875 1750,331.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,361.875C1575,361.875 1575,361.875 1750,361.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,361.875C1575,361.875 1575,391.875 1750,391.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,241.875C1575,241.875 1575,181.875 1750,181.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,241.875C1575,241.875 1575,211.875 1750,211.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,241.875C1575,241.875 1575,241.875 1750,241.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,241.875C1575,241.875 1575,271.875 1750,271.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,241.875C1575,241.875 1575,301.875 1750,301.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,286.875C1225,286.875 1225,211.875 1400,211.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,286.875C1225,286.875 1225,241.875 1400,241.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,286.875C1225,286.875 1225,301.875 1400,301.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,286.875C1225,286.875 1225,361.875 1400,361.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,365.625C875,365.625 875,256.875 1050,256.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,365.625C875,365.625 875,286.875 1050,286.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,365.625C875,365.625 875,474.375 1050,474.375",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,121.875C1575,121.875 1575,91.875 1750,91.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,121.875C1575,121.875 1575,121.875 1750,121.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,121.875C1575,121.875 1575,151.875 1750,151.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,61.875C1925,61.875 1925,1.875 2100,1.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,61.875C1925,61.875 1925,31.875 2100,31.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,61.875C1925,61.875 1925,61.875 2100,61.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,61.875C1925,61.875 1925,91.875 2100,91.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1750,61.875C1925,61.875 1925,121.875 2100,121.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,46.875C1575,46.875 1575,31.875 1750,31.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,46.875C1575,46.875 1575,61.875 1750,61.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,84.375C1225,84.375 1225,46.875 1400,46.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,84.375C1225,84.375 1225,121.875 1400,121.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-28.125C1575,-28.125 1575,-58.125 1750,-58.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-28.125C1575,-28.125 1575,-28.125 1750,-28.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-28.125C1575,-28.125 1575,1.875 1750,1.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-148.125C1575,-148.125 1575,-208.125 1750,-208.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-148.125C1575,-148.125 1575,-178.125 1750,-178.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-148.125C1575,-148.125 1575,-148.125 1750,-148.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-148.125C1575,-148.125 1575,-118.125 1750,-118.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-148.125C1575,-148.125 1575,-88.125 1750,-88.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,-103.125C1225,-103.125 1225,-178.125 1400,-178.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,-103.125C1225,-103.125 1225,-148.125 1400,-148.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,-103.125C1225,-103.125 1225,-88.125 1400,-88.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1050,-103.125C1225,-103.125 1225,-28.125 1400,-28.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-283.125C1575,-283.125 1575,-328.125 1750,-328.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-283.125C1575,-283.125 1575,-298.125 1750,-298.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-283.125C1575,-283.125 1575,-268.125 1750,-268.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1400,-283.125C1575,-283.125 1575,-238.125 1750,-238.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1200,-298.125C1300,-298.125 1300,-313.125 1400,-313.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M1200,-298.125C1300,-298.125 1300,-283.125 1400,-283.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,-106.875C950,-106.875 950,-298.125 1200,-298.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,-106.875C875,-106.875 875,-103.125 1050,-103.125",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M700,-106.875C875,-106.875 875,84.375 1050,84.375",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,316.875C525,316.875 525,-106.875 700,-106.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,316.875C525,316.875 525,365.625 700,365.625",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,316.875C525,316.875 525,740.625 700,740.625",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,-226.875C525,-226.875 525,-316.875 700,-316.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,-226.875C525,-226.875 525,-286.875 700,-286.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,-226.875C525,-226.875 525,-256.875 700,-256.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,-226.875C525,-226.875 525,-226.875 700,-226.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,-226.875C525,-226.875 525,-196.875 700,-196.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,-226.875C525,-226.875 525,-166.875 700,-166.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "link",
    d: "M350,-226.875C525,-226.875 525,-136.875 700,-136.875",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(350,316.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Subvert Legitimate Package")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(350,-226.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Create Name Confusion with Legitimate Package")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(300,-316.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Develop and Advertise Distinct Malicious Package from Scratch")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Conduct Open-Source Supply Chain Attack")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,991.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "8px, 3px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Infect through Malicious Component")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,961.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Vulnerabilities")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,931.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Weak Configuration")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,961.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Compromise Hosting System")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,961.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Existing Session")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,931.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Social Engineering to Obtain Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,901.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Leaked API Tokens")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,871.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bruteforce")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,841.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Compromised Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,901.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Take-over Legitimate Account")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,871.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bribe or Blackmail Legitimate User")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,886.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Compromise User (Project Maintainer/Administrator)")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,924.375)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Inject into Hosting System")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,841.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "8px, 3px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Infect through Malicious Component")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,811.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Vulnerabilities")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,781.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Weak Configuration")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,811.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Compromise Maintainer System")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,751.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(255, 215, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Become a Maintainer")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,751.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Existing Session")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,721.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Social Engineering to Obtain Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,691.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Leaked API Tokens")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,661.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bruteforce")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,631.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Compromised Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,691.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Take-over Legitimate Account")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,661.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bribe or Blackmail Legitimate User")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,736.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Distribute as Package Maintainer")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,661.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Prevent Update to Non-Vulnerable Version")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,631.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Abuse Dependency Resolution Mechanism")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,601.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Tamper Legitimate URL")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,571.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "DNS Cache Poisoning")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,541.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "MITM Attack")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,586.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Mask Legitimate Package")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,556.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Dangling Reference")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,740.625)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Distribute Malicious Version of Legitimate Package")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,541.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "8px, 3px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Infect through Malicious Component")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,511.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Vulnerabilities")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,481.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Weak Configuration")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,511.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Compromise Build System")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,511.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Existing Session")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,481.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Social Engineering to Obtain Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,451.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Leaked API Tokens")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,421.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bruteforce")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,391.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Compromised Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,451.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Take-over Legitimate Account")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,421.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bribe or Blackmail Legitimate User")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,436.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Compromise User (Project Maintainer/Administrator)")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,474.375)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Tamper with Exposed Build System")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,391.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "8px, 3px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Infect through Malicious Component")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,361.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Vulnerabilities")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,331.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Weak Configuration")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,361.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Compromise Maintainer System")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,301.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(255, 215, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Become a Maintainer")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,301.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Existing Session")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,271.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Social Engineering to Obtain Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,241.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Leaked API Tokens")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,211.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bruteforce")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,181.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Compromised Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,241.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Take-over Legitimate Account")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,211.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bribe or Blackmail Legitimate User")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,286.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Tamper Build Job as Maintainer")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,256.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Run Malicious Build")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,365.625)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Inject During the Build of Legitimate Package")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,151.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "8px, 3px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Infect through Malicious Component")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,121.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Vulnerabilities")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,91.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Weak Configuration")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,121.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Compromise Version Control System")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,121.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Existing Session")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,91.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Social Engineering to Obtain Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,61.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Leaked API Tokens")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,31.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bruteforce")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(2100,1.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Compromised Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,61.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Take-over Legitimate Account")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,31.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bribe or Blackmail Legitimate User")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,46.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Compromise User (Project Maintainer/Administrator)")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,84.375)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Tamper with Version Control System")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,1.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "8px, 3px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Infect through Malicious Component")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-28.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Vulnerabilities")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-58.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Weak Configuration")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,-28.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(0, 100, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Compromise Maintainer System")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,-88.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(255, 215, 0)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Become a Maintainer")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-88.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Existing Session")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-118.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Social Engineering to Obtain Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-148.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Leaked API Tokens")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-178.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bruteforce")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-208.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Reuse of Compromised Credentials")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,-148.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Take-over Legitimate Account")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,-178.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(178, 34, 34)",
      fill: "url(&quot",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Bribe or Blackmail Legitimate User")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1050,-103.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Contribute as Maintainer")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-238.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Hide in Generated/Compiled/Minified Code")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-268.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Prevent Display of File Differences")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-298.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Use Homoglyphs")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1750,-328.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Exploit Unicode Bidirectional Algorithm")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,-283.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Exploit Rendering Weakness")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1400,-313.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Make Immature Vulnerability Exploitable")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(1200,-298.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Introduce Malicious Code through Hypocrite Merge Request")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,-106.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: -13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "end"
  }, "Inject into Sources of Legitimate Package")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,-136.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Similarity Attack")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,-166.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Brandjacking")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,-196.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Built-In Package")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,-226.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Typosquatting")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,-256.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Manipulating Word Separators")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,-286.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Altering Word Order")), /*#__PURE__*/React.createElement("g", {
    className: "node",
    transform: "translate(700,-316.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    style: {
      stroke: "rgb(70, 130, 180)",
      fill: "rgb(255, 255, 255)",
      strokeDasharray: "0px, 0px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    dy: ".35em",
    style: {
      fontSize: 12,
      fillOpacity: 1
    },
    textAnchor: "start"
  }, "Combosquatting")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackgraph);
export default __webpack_public_path__ + "static/media/attackgraph.e3fed8db89889517a0c8c4e54a662411.svg";
export { ForwardRef as ReactComponent };